import React from 'react';
import PropTypes from 'prop-types';
import GroupHeading from '../atoms/GroupHeading';
import GlobalSearchResultRow from './GlobalSearchResultRow';
import { MAX_ROWS_PER_GROUP, TYPE_ICONS } from '../constants';

function GlobalSearchResultGroup({ group, term, startIndex, activeIndex, onRowHover, rowRefs, onNavigate }) {
  const Icon = TYPE_ICONS[group.key];
  const rows = group.rows.slice(0, MAX_ROWS_PER_GROUP);

  return (
    <section>
      <GroupHeading
        icon={Icon && <Icon className="size-(--gs-group-icon) text-llama-grey-10" />}
        label={group.label}
        count={rows.length}
        seeAllUrl={group.seeAllUrl}
        onNavigate={onNavigate}
      />
      <ul>
        {rows.map((row, index) => {
          const flatIndex = startIndex + index;
          return (
            <GlobalSearchResultRow
              key={row.url || flatIndex}
              type={group.key}
              row={row}
              term={term}
              active={flatIndex === activeIndex}
              onHover={() => onRowHover(flatIndex)}
              innerRef={(node) => {
                rowRefs.current[flatIndex] = node;
              }}
              onNavigate={onNavigate}
            />
          );
        })}
      </ul>
    </section>
  );
}

GlobalSearchResultGroup.propTypes = {
  group: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    seeAllUrl: PropTypes.string,
    rows: PropTypes.array.isRequired,
  }).isRequired,
  term: PropTypes.string.isRequired,
  startIndex: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onRowHover: PropTypes.func.isRequired,
  rowRefs: PropTypes.object.isRequired,
  onNavigate: PropTypes.func.isRequired,
};

export default GlobalSearchResultGroup;
